import { render, staticRenderFns } from "./spider-window-messagebox.vue?vue&type=template&id=ca5c6e86&scoped=true&"
import script from "./spider-window-messagebox.vue?vue&type=script&lang=js&"
export * from "./spider-window-messagebox.vue?vue&type=script&lang=js&"
import style0 from "./spider-window-messagebox.vue?vue&type=style&index=0&id=ca5c6e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5c6e86",
  null
  
)

export default component.exports